export const subscriptionPlans = [
  {
    id: 1,
    name: 'Essential',
    pt1: 'Maximum 1 Chatbot',
    pt2: 'Unlimited plugins',
    pt3: 'Standard email support for assistance',
    btn: 'Get Basic',
    pricing: {
      monthly: '€11.99',
      yearly: '€119.99'
    },
    chatOptions: [
      { 
        chats: 250, 
        monthlyPlanId: 0, 
        yearlyPlanId: 1,
        pricing: {
          monthly: '€19',
          yearly: '€194'
        }
      },
      { 
        chats: 1000, 
        monthlyPlanId: 2, 
        yearlyPlanId: 3,
        pricing: {
          monthly: '€39',
          yearly: '€398'
        }
      },
      { 
        chats: 10000, 
        monthlyPlanId: 4, 
        yearlyPlanId: 5,
        pricing: {
          monthly: '€99',
          yearly: '€1.010'
        }
      }
    ]
  },
  {
    id: 2,
    name: 'Advanced',
    pt1: 'Maximum 2 Chatbots',
    pt2: 'Unlimited plugins',
    pt3: 'Standard email support for assistance',
    btn: 'Get Standard',
    pricing: {
      monthly: '€49.99',
      yearly: '€499.99'
    },
    chatOptions: [
      { 
        chats: 5000, 
        monthlyPlanId: 6, 
        yearlyPlanId: 7,
        pricing: {
          monthly: '€149',
          yearly: '€1.520'
        }
      },
      { 
        chats: 10000, 
        monthlyPlanId: 8, 
        yearlyPlanId: 9,
        pricing: {
          monthly: '€199',
          yearly: '€2.030'
        }
      },
      { 
        chats: 50000, 
        monthlyPlanId: 10, 
        yearlyPlanId: 11,
        pricing: {
          monthly: '€349',
          yearly: '€3.560'
        }
      }
    ]
  },
  {
    id: 3,
    name: 'Business',
    pt1: 'Maximum 5 Chatbots',
    pt2: 'Unlimited plugins',
    pt3: 'Premium email support for assistance',
    btn: 'Get Premium',
    pricing: {
      monthly: '€99.99',
      yearly: '€999.99'
    },
    chatOptions: [
      { 
        chats: 50000, 
        monthlyPlanId: 12, 
        yearlyPlanId: 13,
        pricing: {
          monthly: '€499',
          yearly: '€5.090'
        }
      },
      { 
        chats: 100000, 
        monthlyPlanId: 14, 
        yearlyPlanId: 15,
        pricing: {
          monthly: '€699',
          yearly: '€7.130'
        }
      },
      { 
        chats: 500000, 
        monthlyPlanId: 16, 
        yearlyPlanId: 17,
        pricing: {
          monthly: '€1.499',
          yearly: '€15.290'
        }
      }
    ]
  }
];

// Legacy arrays for backward compatibility
export const subscriptionArrayMonth = [
  {
    id: 1,
    name: 'Essential',
    amount: '€11.99',
    pt1: 'Maximum 1 Chatbot',
    pt2: 'Set up 1 Condition for your agent',
    pt3: 'Unlimited plugins',
    pt4: 'Up to 2000 responses per month',
    pt5: 'Standard email support for assistance',
    btn: 'Get Basic',
    chatOptions: [
      { chats: 250, planId: 0 },
      { chats: 1000, planId: 2 },
      { chats: 10000, planId: 4 }
    ]
  },
  {
    id: 2,
    name: 'Advanced Plans (2 Chatbots)',
    amount: '€49.99',
    pt1: 'Maximum 3 Agents',
    pt2: 'Set up 6 Condition for each agent',
    pt3: 'Unlimited plugins',
    pt4: 'Up to 12000 responses per month',
    pt5: 'Standard email support for assistance',
    btn: 'Get Standard',
    chatOptions: [
      { chats: 5000, planId: 6 },
      { chats: 10000, planId: 8 },
      { chats: 50000, planId: 10 }
    ]
  },
  {
    id: 3,
    name: 'Business Plans (5 Chatbots)',
    amount: '€99.99',
    pt1: 'Maximum 7 Agents',
    pt2: 'Set up 10 Conditions for each agent',
    pt3: 'Unlimited plugins',
    pt4: 'Up to 28000 responses per month',
    pt5: 'Premium email support for assistance',
    btn: 'Get Premium',
    chatOptions: [
      { chats: 50000, planId: 12 },
      { chats: 100000, planId: 14 },
      { chats: 500000, planId: 16 }
    ]
  }
];

export const subscriptionArrayYearly = [
  {
    id: 6,
    name: 'Essential',
    amount: '€119.99',
    pt1: 'Gedeelde server',
    pt2: 'Tot maximaal 1 agent',
    pt3: '€0,01 per bericht',
    pt4: '24/7 support',
    pt5: '',
    btn: 'Get Basic',
    chatOptions: [
      { chats: 250, planId: 1 },
      { chats: 1000, planId: 3 },
      { chats: 10000, planId: 5 }
    ]
  },
  {
    id: 7,
    name: 'Advanced Plans (2 Chatbots)',
    amount: '€499.99',
    pt1: 'Gedeelde server',
    pt2: 'Tot maximaal 3 agent',
    pt3: '€0,01 per bericht',
    pt4: '24/7 support',
    pt5: 'Data Analytics',
    btn: 'Get Standard',
    chatOptions: [
      { chats: 5000, planId: 7 },
      { chats: 10000, planId: 9 },
      { chats: 50000, planId: 11 }
    ]
  },
  {
    id: 8,
    name: 'Business Plans (5 Chatbots)',
    amount: '€999.99',
    pt1: 'Eigen server',
    pt2: 'Maximaal 1 model',
    pt3: 'Onbeperkt agents',
    pt4: '€0,005 per bericht',
    pt5: 'Data Analytics',
    btn: 'Get Premium',
    chatOptions: [
      { chats: 50000, planId: 13 },
      { chats: 100000, planId: 15 },
      { chats: 500000, planId: 17 }
    ]
  }
];
